/**
 * 邮箱
 * @param {*} s
 */
export function isEmail (s) {
  return /^[\w\.\'\-]+@([a-zA-Z0-9-]+[.]{1})+[a-zA-Z0-9-]+$/.test(s)
  // return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile (s) {
  return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone (s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}
// 密码
export function isPsw (s) {
  var passwordReg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,20}$/;
  var passwordReg1 = /[^a-zA-Z\d~!@#$ %^&*()/\|\s,.<>?"'();:_+-=\[\]{}]+|\s+/;
  var bool1 = passwordReg1.test(s) ? false : true;
  var bool2 = passwordReg.test(s);
  if (bool1 === false || bool2 === false) {
    return false
  } else {
    return  true
  }
}

// 旧密码
export function isOldPsw(s) {
  if (!s) return  false;
  return /^$|^.{4,20}$/.test(s)
}

// 密保问题
export function isMibao(s) {
  var reg1 = /^[\u4e00-\u9fa5]{1,20}$/;
  var reg2 = /^[A-Za-z]{2,40}$/
  if (reg1.test(s) || reg2.test(s)) {
    return true
  } else {
    return  false
  }
}

// 昵称
export function isNickName(s) {
  var reg =  /'/;
  if (reg.test(s)) {
    return  false
  } else {
    return  true
  }
}



// WEBPACK FOOTER //
// ./src/utils/validate.js